/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CorrectRegistrationCountryRequest interface.
 */
export function instanceOfCorrectRegistrationCountryRequest(value) {
    if (!('country' in value) || value['country'] === undefined)
        return false;
    if (!('reason' in value) || value['reason'] === undefined)
        return false;
    return true;
}
export function CorrectRegistrationCountryRequestFromJSON(json) {
    return CorrectRegistrationCountryRequestFromJSONTyped(json, false);
}
export function CorrectRegistrationCountryRequestFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'country': json['country'],
        'reason': json['reason'],
    };
}
export function CorrectRegistrationCountryRequestToJSON(json) {
    return CorrectRegistrationCountryRequestToJSONTyped(json, false);
}
export function CorrectRegistrationCountryRequestToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'country': value['country'],
        'reason': value['reason'],
    };
}
